import {Injectable} from "@angular/core";
import { HttpClient } from "@angular/common/http";

import {map, Observable} from "rxjs";
import {Driver} from "@commons/models/domain/Driver";

import {BaseHttpService} from "./base-http.service";

@Injectable({
  providedIn: 'root'
})
export class NewDriversHttpService extends BaseHttpService {

  constructor(private httpClient: HttpClient) {
    super();
  }

  get(): Observable<Driver[]> {
    return this.httpClient.get<any>(this.getUrl('/GetDriverList'))
      .pipe(map(result => result.Result.Result));
  }

}
